import { APIOps } from "@/apis/api-config";
import ApiPaths from "@/apis/base-api-paths";

export default class AdminApi extends ApiPaths {
  async adminSummary(
    startDate: string,
    endDate: string,
  ): Promise<APIOps["get_admin_summary_api_admin_summary_get"]["responses"]["200"]["content"]["application/json"]> {
    const params: APIOps["get_admin_summary_api_admin_summary_get"]["parameters"]["query"] = {
      startDate: startDate,
      endDate: endDate,
    };
    return (await this.get(this.toAdminURL(`summary?startDate=${params.startDate}&endDate=${params.endDate}`))).data;
  }
  async getAdminUserTable(
    params: APIOps["get_admin_user_table_api_admin_user_table_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_user_table_api_admin_user_table_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`user-table`)}`, { params: params })).data;
  }
  async adminUserTableDetail(
    firebase_auth_user_id: string,
  ): Promise<
    APIOps["get_admin_user_table_detail_api_admin_user_table_detail_get"]["responses"]["200"]["content"]["application/json"]
  > {
    const params: APIOps["get_admin_user_table_detail_api_admin_user_table_detail_get"]["parameters"]["query"] = {
      firebase_auth_user_id: firebase_auth_user_id,
    };
    return (await this.get(this.toAdminURL(`user-table/detail?firebase_auth_user_id=${params.firebase_auth_user_id}`)))
      .data;
  }
  async adminUserInsight(
    startDate: string,
    endDate: string,
  ): Promise<
    APIOps["get_admin_user_insight_api_admin_user_table_insight_get"]["responses"]["200"]["content"]["application/json"]
  > {
    const params: APIOps["get_admin_user_insight_api_admin_user_table_insight_get"]["parameters"]["query"] = {
      startDate: startDate,
      endDate: endDate,
    };
    return (
      await this.get(this.toAdminURL(`user-table-insight?startDate=${params.startDate}&endDate=${params.endDate}`))
    ).data;
  }
  async getAdminInstagramTable(
    params: APIOps["get_admin_instagram_table_api_admin_instagram_table_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_instagram_table_api_admin_instagram_table_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`instagram-table`)}`, { params: params })).data;
  }
  async adminInstagramTableDetail(
    instagram_account_id: string,
  ): Promise<
    APIOps["get_admin_instagram_table_detail_api_admin_instagram_table_detail_get"]["responses"]["200"]["content"]["application/json"]
  > {
    const params: APIOps["get_admin_instagram_table_detail_api_admin_instagram_table_detail_get"]["parameters"]["query"] =
      {
        instagram_account_id: instagram_account_id,
      };
    return (
      await this.get(this.toAdminURL(`instagram-table/detail?instagram_account_id=${params.instagram_account_id}`))
    ).data;
  }
  async adminInstagramInsight(
    startDate: string,
    endDate: string,
  ): Promise<
    APIOps["get_admin_instagram_insight_api_admin_instagram_table_insight_get"]["responses"]["200"]["content"]["application/json"]
  > {
    const params: APIOps["get_admin_instagram_insight_api_admin_instagram_table_insight_get"]["parameters"]["query"] = {
      startDate: startDate,
      endDate: endDate,
    };
    return (
      await this.get(this.toAdminURL(`instagram-table-insight?startDate=${params.startDate}&endDate=${params.endDate}`))
    ).data;
  }
  async adminFeedTable(
    keyword: string,
    startDate: string,
    endDate: string,
  ): Promise<
    APIOps["get_admin_feed_media_api_admin_feed_list_get"]["responses"]["200"]["content"]["application/json"]
  > {
    const params: APIOps["get_admin_feed_media_api_admin_feed_list_get"]["parameters"]["query"] = {
      keyword: keyword,
      startDate: startDate,
      endDate: endDate,
    };
    return (
      await this.get(
        this.toAdminURL(`feed/list?keyword=${params.keyword}&startDate=${params.startDate}&endDate=${params.endDate}`),
      )
    ).data;
  }
  async adminFirstFeedTable(
    keyword: string,
    startDate: string,
    endDate: string,
  ): Promise<
    APIOps["get_admin_first_feed_media_api_admin_first_feed_list_get"]["responses"]["200"]["content"]["application/json"]
  > {
    const params: APIOps["get_admin_first_feed_media_api_admin_first_feed_list_get"]["parameters"]["query"] = {
      keyword: keyword,
      startDate: startDate,
      endDate: endDate,
    };
    return (
      await this.get(
        this.toAdminURL(
          `first-feed/list?keyword=${params.keyword}&startDate=${params.startDate}&endDate=${params.endDate}`,
        ),
      )
    ).data;
  }
  async adminSignUpQuestionInsight(
    _startDate: string,
    _endDate: string,
  ): Promise<
    APIOps["update_all_user_api_admin_question_signup_answer_get"]["responses"]["200"]["content"]["application/json"]
  > {
    // const params: APIOps["update_all_user_api_admin_question_signup_answer_get"]["parameters"]["query"] = {
    //   startDate: _startDate,
    //   endDate: _endDate,
    // };
    return (await this.get(this.toAdminURL(`question/signup-answer`))).data;
  }

  async patchInstagramAccountPlan(
    params: APIOps["update_plan_for_instagram_account_api_admin_instagram_account_plan_patch"]["parameters"]["query"],
  ): Promise<
    APIOps["update_plan_for_instagram_account_api_admin_instagram_account_plan_patch"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.patch(
        `${this.toAdminURL(
          `instagram-account/plan?instagram_account_id=${params.instagram_account_id}&stripe_subscription_id=${params.stripe_subscription_id}`,
        )}`,
      )
    ).data;
  }

  async exportUserTableCsv(
    params: APIOps["get_admin_user_table_api_admin_user_table_get"]["parameters"]["query"],
  ): Promise<string> {
    return (await this.get(`${this.toAdminURL(`user-table/export/csv`)}`, { params: params })).data;
  }

  async exportInstagramTableCsv(
    params: APIOps["get_admin_instagram_table_api_admin_instagram_table_get"]["parameters"]["query"],
  ): Promise<string> {
    return (await this.get(`${this.toAdminURL(`instagram-table/export/csv`)}`, { params: params })).data;
  }

  async exportFeedTableCsv(keyword?: string): Promise<string> {
    const params = keyword ? { keyword } : {};
    return (await this.get(`${this.toAdminURL(`feed/v2/export/csv`)}`, { params: params })).data;
  }

  async exportReelTableCsv(keyword?: string): Promise<string> {
    const params = keyword ? { keyword } : {};
    return (await this.get(`${this.toAdminURL(`reel/v2/export/csv`)}`, { params: params })).data;
  }

  async getAdminInstagramTableV2(
    params?: APIOps["get_admin_firestore_instagram_list_api_admin_instagram_account_v2_list_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_firestore_instagram_list_api_admin_instagram_account_v2_list_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`instagram-account/v2/list`)}`, { params: params })).data;
  }

  async getAdminInstagramInsightV2(): Promise<
    APIOps["get_admin_instagram_insight_api_admin_instagram_table_insight_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`instagram-account/v2/insight`)}`)).data;
  }

  async getAdminFeedTableV2(
    params?: APIOps["get_admin_firestore_feed_list_api_admin_feed_v2_list_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_firestore_feed_list_api_admin_feed_v2_list_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`feed/v2/list`)}`, { params: params })).data;
  }

  async getAdminReelTableV2(
    params?: APIOps["get_admin_firestore_reel_list_api_admin_reel_v2_list_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_firestore_reel_list_api_admin_reel_v2_list_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`reel/v2/list`)}`, { params: params })).data;
  }

  async getInstagramCredentials(
    instagram_business_id: string,
  ): Promise<
    APIOps["get_instagram_credentials_api_admin_instagram_account_v2_credentials__instagram_business_id__get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`instagram-account/v2/credentials/${instagram_business_id}`))).data;
  }

  async adminWithdrawPreCheck(
    firebase_auth_user_id: string,
  ): Promise<
    APIOps["admin_withdraw_pre_check_api_admin_user_table_withdraw_pre_check_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.get(this.toAdminURL(`user-table/withdraw/pre-check?firebase_auth_user_id=${firebase_auth_user_id}`))
    ).data;
  }

  async adminWithdrawExecute(
    firebase_auth_user_id: string,
  ): Promise<
    APIOps["admin_withdraw_execute_api_admin_user_table_withdraw__firebase_auth_user_id__delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(this.toAdminURL(`user-table/withdraw/${firebase_auth_user_id}`))).data;
  }

  async adminWithdrawals(
    limit = 200,
  ): Promise<
    APIOps["admin_withdrawals_api_admin_user_table_withdrawals_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`user-table/withdrawals?limit=${limit}`))).data;
  }

  async getAdminAdAccountsList(
    params?: APIOps["get_admin_ad_accounts_list_api_admin_ad_accounts_list_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_ad_accounts_list_api_admin_ad_accounts_list_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`ad-accounts/list`)}`, { params: params })).data;
  }

  async getAdminAdAccountCampaigns(
    ad_account_id: string,
    params?: APIOps["get_admin_ad_account_campaigns_api_admin_ad_accounts__ad_account_id__campaigns_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_admin_ad_account_campaigns_api_admin_ad_accounts__ad_account_id__campaigns_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`${this.toAdminURL(`ad-accounts/${ad_account_id}/campaigns`)}`, { params: params })).data;
  }

  async getAdminCampaignInsights(
    ad_account_id: string,
    campaign_id: string,
    params?: { start_date?: string; end_date?: string },
  ): Promise<
    APIOps["get_admin_campaign_insights_api_admin_ad_accounts__ad_account_id__campaigns__campaign_id__insights_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.get(this.toAdminURL(`ad-accounts/${ad_account_id}/campaigns/${campaign_id}/insights`), { params })
    ).data;
  }

  async postCreateImpersonateToken(organizationId: string): Promise<{
    token: string;
    expires_at: string;
  }> {
    return (
      await this.post(
        this.toAdminURL("create-impersonate-token"),
        {},
        {
          params: { organization_id: organizationId },
        },
      )
    ).data;
  }

  async getPaidCustomers(
    params?: APIOps["get_paid_customers_api_admin_paid_accounts_customers_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_paid_customers_api_admin_paid_accounts_customers_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`paid-accounts/customers`), { params })).data;
  }

  async getPaidCustomersSummary(): Promise<
    APIOps["get_paid_customers_summary_api_admin_paid_accounts_customers_summary_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`paid-accounts/customers/summary`))).data;
  }

  async exportPaidCustomersCsv(
    params?: APIOps["export_paid_customers_csv_api_admin_paid_accounts_customers_export_csv_get"]["parameters"]["query"],
  ): Promise<string> {
    return (await this.get(this.toAdminURL(`paid-accounts/customers/export/csv`), { params })).data;
  }

  async getPaidInstagramAccounts(
    params?: APIOps["get_paid_instagram_accounts_api_admin_paid_accounts_instagram_accounts_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_paid_instagram_accounts_api_admin_paid_accounts_instagram_accounts_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`paid-accounts/instagram-accounts`), { params })).data;
  }

  async exportPaidInstagramAccountsCsv(
    params?: APIOps["export_paid_instagram_accounts_csv_api_admin_paid_accounts_instagram_accounts_export_csv_get"]["parameters"]["query"],
  ): Promise<string> {
    return (await this.get(this.toAdminURL(`paid-accounts/instagram-accounts/export/csv`), { params })).data;
  }

  async getPaidEvents(
    params?: APIOps["get_paid_events_api_admin_paid_accounts_events_get"]["parameters"]["query"],
  ): Promise<
    APIOps["get_paid_events_api_admin_paid_accounts_events_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`paid-accounts/events`), { params })).data;
  }

  async exportPaidEventsCsv(
    params?: APIOps["export_paid_events_csv_api_admin_paid_accounts_events_export_csv_get"]["parameters"]["query"],
  ): Promise<string> {
    return (await this.get(this.toAdminURL(`paid-accounts/events/export/csv`), { params })).data;
  }

  async getCustomerLinkedInstagrams(
    customer_id: string,
  ): Promise<
    APIOps["get_customer_linked_instagrams_api_admin_paid_accounts_customers__customer_id__instagram_accounts_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toAdminURL(`paid-accounts/customers/${customer_id}/instagram-accounts`))).data;
  }
}
